import React, { Component } from 'react';

import Calculate from '../components/Calculate/Calculate';
class CalculateTheme extends Component {
    render() {
        return (
            <div className="main">
                <Calculate />
            </div>
        );
    }
}

export default CalculateTheme;